export class ToastAlert {
  type: string;
  message: string;
  iconShape: string;
  autohide: boolean;

  constructor(type: string, message: string) {
    this.type = type;
    this.message = message;
    this.computeProperties();
  }

  private computeProperties() {
    switch (this.type) {
    case 'info':
    case 'success':
      this.iconShape = 'info';
      this.autohide = true;
      break;
    case 'warning':
      this.iconShape = 'warning';
      this.autohide = true;
      break;
    case 'danger':
      this.iconShape = 'warning';
      this.autohide = false;
      break;
    }
  }

}
